import React from 'react';
import { FormGroup, Stack, Typography, Switch } from '@mui/material';
import { IssueState } from 'shared/constants/issues';
import intl from 'react-intl-universal';
import { MODAL_TYPES } from 'views/IssueDetails';
import PropTypes from 'prop-types';

const propTypes = {
  issue: PropTypes.object.isRequired,
  setConfirmModalType: PropTypes.func.isRequired,
  setConfirmModalOpen: PropTypes.func.isRequired,
  issueIsDone: PropTypes.bool.isRequired,
};

export const WarningToggle = ({
  issue,
  setConfirmModalType,
  setConfirmModalOpen,
  issueIsDone,
}) => {
  return (
    <FormGroup sx={{ mr: 5 }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography
          data-testid="kanban-issueDetails-state-normal"
          style={{
            fontSize: '16px',
            color: issue.state === IssueState.NORMAL ? 'black' : 'grey',
          }}>
          {intl.get('shared_value_state_normal')}
        </Typography>

        <Switch
          data-testid="kanban-issueDetails-state-switch"
          checked={issue.state === IssueState.WARNING}
          color="error"
          onChange={() => {
            setConfirmModalType(MODAL_TYPES.SWITCH_CHANGE);
            setConfirmModalOpen(true);
          }}
          disabled={issueIsDone}
        />
        <Typography
          data-testid="kanban-issueDetails-state-warning"
          style={{
            fontSize: '16px',
            fontWeight: issue.state === IssueState.WARNING ? 'bold' : 'normal',
            color: issue.state === IssueState.WARNING ? 'red' : 'grey',
          }}>
          {intl.get('shared_value_state_warning')}
        </Typography>
      </Stack>
    </FormGroup>
  );
};

WarningToggle.propTypes = propTypes;
